function generateSrcSetString(imageTemplate, imageView, availableImageSizes, imageQuality, imagesphereAspectRatio) {
    const srcset = availableImageSizes.map((size) => {
        const src = generateSrcString(imageTemplate, imageView, size, imageQuality, imagesphereAspectRatio);
        return `${src} ${size}w`;
    });
    return srcset.join(', ');
}

function generatePlpSrcSetString(imageTemplate, imageView, plpImageSrcSet, imageQuality, imagesphereAspectRatio) {
    const { desktopImageSizes, mobileImageSizes } = plpImageSrcSet;

    const desktopImageSizesArray = typeof desktopImageSizes === 'string' ? [desktopImageSizes] : desktopImageSizes;

    const mobileImageSizesArray = typeof mobileImageSizes === 'string' ? [mobileImageSizes] : mobileImageSizes;

    const desktopSrcset = desktopImageSizesArray.map((size) => {
        // size info is like ['360 1x', '578 2x']
        const sizeInfo = size.split(' ');
        const src = generateSrcString(imageTemplate, imageView, sizeInfo[0], imageQuality, imagesphereAspectRatio);
        return `${src} ${sizeInfo[1]}`;
    });

    const mobileSrcset = mobileImageSizesArray.map((size) => {
        const sizeInfo = size.split(' ');
        const src = generateSrcString(imageTemplate, imageView, sizeInfo[0], imageQuality, imagesphereAspectRatio);
        return `${src} ${sizeInfo[1]}`;
    });
    return {
        desktopSrcset: desktopSrcset.join(', '),
        mobileSrcset: mobileSrcset.join(', '),
    };
}

function generateSrcString(imageTemplate, imageView, imageSize, imageQuality, imagesphereAspectRatio) {
    const aspectRatio = imagesphereAspectRatio || '';
    const quality = imageQuality ? `_q${imageQuality}` : '';
    return imageTemplate?.replace('{view}', imageView).replace('{width}', imageSize + aspectRatio + quality);
}

export function getProductImageFromTemplate(imageTemplate, view, availableImageSizes, imageQuality, zoomedImageQuality = null, imagesphereAspectRatio) {
    return {
        // TODO: what is the logic to choose the availableImageSizes
        url: generateSrcString(imageTemplate, view, availableImageSizes[0], imageQuality, imagesphereAspectRatio),
        srcSet: generateSrcSetString(imageTemplate, view, availableImageSizes, imageQuality, imagesphereAspectRatio),
        zoomUrl: generateSrcString(imageTemplate, view, availableImageSizes[0], zoomedImageQuality, imagesphereAspectRatio),
        zoomSrcSet: generateSrcSetString(imageTemplate, view, availableImageSizes, zoomedImageQuality, imagesphereAspectRatio),
    };
}

export default function getProductImage(product, availableImageSizes, imageQuality, index = 0, imagesphereAspectRatio, plpImageSrcSet) {
    try {
        // fallback to product to handle version 2 of wishlist API
        const selectedProductColor = product.productColours?.find((c) => c.selected) || product.productColours?.[0] || product;
        const primaryImageView = selectedProductColor.imageViews[index];
        const secondaryImageView = selectedProductColor.imageViews[1];

        const primaryPlpSrcset = plpImageSrcSet
            ? {
                  primaryPlpSrcset: generatePlpSrcSetString(
                      selectedProductColor.imageTemplate,
                      primaryImageView,
                      plpImageSrcSet,
                      imageQuality,
                      imagesphereAspectRatio,
                  ),
              }
            : {};

        const primaryImage = {
            primary: generateSrcString(selectedProductColor.imageTemplate, primaryImageView, availableImageSizes[0], imageQuality, imagesphereAspectRatio),
            primarySrcset: generateSrcSetString(
                selectedProductColor.imageTemplate,
                primaryImageView,
                availableImageSizes,
                imageQuality,
                imagesphereAspectRatio,
            ),
            ...primaryPlpSrcset,
        };

        const secondaryPlpSrcset = plpImageSrcSet
            ? {
                  secondaryPlpSrcset: generatePlpSrcSetString(
                      selectedProductColor.imageTemplate,
                      secondaryImageView,
                      plpImageSrcSet,
                      imageQuality,
                      imagesphereAspectRatio,
                  ),
              }
            : {};

        const secondaryImage = secondaryImageView
            ? {
                  secondary: generateSrcString(
                      selectedProductColor.imageTemplate,
                      secondaryImageView,
                      availableImageSizes[0],
                      imageQuality,
                      imagesphereAspectRatio,
                  ),
                  secondarySrcset: generateSrcSetString(
                      selectedProductColor.imageTemplate,
                      secondaryImageView,
                      availableImageSizes,
                      imageQuality,
                      imagesphereAspectRatio,
                  ),
                  ...secondaryPlpSrcset,
              }
            : {};

        return {
            ...primaryImage,
            ...secondaryImage,
        };
    } catch (error) {
        //do nothing
    }
}
